<template>
    <b-card class="error-card mb-4" bg-variant="white" v-if="validationErrors.length">
        <b-row>
            <b-col cols="12" md="12" class="mb-2">
                <h6 class="mb-3 error-card__title">
                    <b-icon-exclamation-circle></b-icon-exclamation-circle>
                    Felmeddelande
                </h6>
                <b-list-group class="mb-3" v-for="(error, eIndex) in validationErrors" :key="'e-' + eIndex">
                    <b-list-group-item v-html="error"></b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col cols="12" md="12" v-if="scrollToTop">
                <b-button variant="outline-primary" block @click="scrollToTop" class="btn-action">
                    <b-icon-arrow-up-circle></b-icon-arrow-up-circle>
                    {{ $t('common.scrollToTop') }}
                </b-button>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import { BIconArrowUpCircle, BIconExclamationCircle } from 'bootstrap-vue';

export default {
    name: 'ErrorMessages',
    components: {
        BIconArrowUpCircle,
        BIconExclamationCircle
    },
    props: {
        scrollToTop: {},
        validationErrors: {}
    }
}
</script>
<style scoped>
.error-card__title {
    color: #fd5050;
}
</style>
